import {
	useSelectCofCategories,
	useSelectLofCategories,
} from '@Selectors/Risk.selectors';
import { Category } from '@Types/category.types';
import { GridColDef } from '@innovyze/stylovyze';
import { useMemo } from 'react';
import { useGlobalization } from '@Translations/useGlobalization';

const createComponentScoreGridRow = (
	scoreType: string,
	categoryName: string,
	componentName: string,
	scoreTypeFE: string,
): GridColDef => ({
	field: `${scoreType}_${categoryName}_${componentName}`,
	headerName: `${scoreTypeFE} ${categoryName}-${componentName}`,
	flex: 1,
	minWidth: 150,
	sortable: true,
	filterable: false,
});

const createCategoryComponents = (
	category: Category,
	scoreType: string,
	scoreTypeFE: string,
) =>
	category?.components
		?.filter(component => component.name)
		?.map(component => [
			createComponentScoreGridRow(
				scoreType,
				category.name,
				component.name,
				scoreTypeFE,
			),
			createComponentScoreGridRow(
				`${scoreType}Raw`,
				category.name,
				component.name,
				`${scoreTypeFE}Raw`,
			),
		])
		.flat();

export default function useGetWeightedScores() {
	const { t } = useGlobalization();
	const lofCategories = useSelectLofCategories();
	const cofCategories = useSelectCofCategories();

	const lofScores = useMemo(
		() =>
			lofCategories
				.filter(category => category.components.length > 0)
				.map(category =>
					createCategoryComponents(category, 'LOF', t('LoF')),
				)
				.flat(),
		[lofCategories],
	);

	const cofScores = useMemo(
		() =>
			cofCategories
				.filter(category => category.components.length > 0)
				.map(category =>
					createCategoryComponents(category, 'COF', t('CoF')),
				)
				.flat(),
		[cofCategories],
	);

	return { lofScores, cofScores };
}
